import { ISharepointDocumentLibrarySite } from "../../interfaces/ISharepointDocumentLibrarySite";
import {
  getSharePointContentTypeFields,
  getSharePointDocumentLibraryFields
} from "../../services/SharePointRestServices";
import { SharepointFilters } from "../../config/constants";
import { BaseSharepointHelper } from "./sharepointContentTypeHelper";

export class SharepointDocumentLibraryHelper extends BaseSharepointHelper {
  static async getDocumentLibraryFields(accessToken: string, documentLib: ISharepointDocumentLibrarySite) {
    let result = await getSharePointDocumentLibraryFields(
      accessToken,
      documentLib.webUrl,
      documentLib.sharePointListId,
      SharepointFilters.metadata.search
    );

    return result
      .map(item => {
        const field = this.convertMetadataToFields(item);
        return field && {
          ...field,
          webUrl: documentLib.webUrl,
          documentLibrary: documentLib.documentLibrary,
          siteId: documentLib.siteId,
          sharePointListId: documentLib.sharePointListId
        }
      })
      .filter(item => item);
  }

  static async getContentTypeFields(
    accessToken: string,
    documentLib: ISharepointDocumentLibrarySite,
    contentTypeId: string
  ) {
    let result = await getSharePointContentTypeFields(
      accessToken,
      documentLib.webUrl,
      documentLib.sharePointListId,
      contentTypeId,
      SharepointFilters.metadata.search
    );

    return result
      .map(item => {
        const field = this.convertMetadataToFields(item);
        return field && {
          ...field,
          webUrl: documentLib.webUrl,
          documentLibrary: documentLib.documentLibrary,
          siteId: documentLib.siteId
        }
      })
      .filter(item => item);;
  }
}
